import { useMemo } from "react";
import { similarPrintFriendly } from "../lib/color";
import { PaletteSwatch } from "./PaletteSwatch";

export function SimilarColors({ hex, onSelect }) {
  const list = useMemo(() => similarPrintFriendly(hex, 5), [hex]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="space-y-4">
      <div className="flex items-baseline justify-between border-b border-border pb-2">
        <h2 className="text-sm font-bold uppercase tracking-[0.2em]">
          CMYK-Safe Neighbours
        </h2>
        <span className="text-[10px] uppercase tracking-[0.2em] text-muted">
          High print fidelity
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {list.map((c, i) => (
          <PaletteSwatch
            key={c + i}
            hex={c}
            testId={`palette-swatch-similar-${i}`}
            copyTestId={`copy-hex-button-similar-${i}`}
            onSelect={() => onSelect(c)}
          />
        ))}
      </div>
    </section>
  );
}
